import { Routes } from '@angular/router';
import { AuthGuard } from './app/auth/auth.guard';
import { HomeRedirectGuard } from './app/auth/home-redirect.guard';
import { AppLayout } from './app/layout/component/app.layout';
import { Dashboard } from './app/pages/dashboard/dashboard';
import { Documentation } from './app/pages/documentation/documentation';
import { Landing } from './app/pages/landing';
import { Notfound } from './app/pages/notfound/notfound';
import { WatchComponent } from './app/pages/jornalmove/watch/watch.component';
import { UploadFileComponent } from './app/pages/jornalmove/upload-file/upload-file.component';
import { CreateAccountComponent } from './app/pages/management/create-account/create-account.component';
import { MaintainAccountComponent } from './app/pages/management/maintain-account/maintain-account.component';
import { JournalReportComponent } from './app/pages/jornalmove/report/journal-report.component';
import { IndexInsertComponent } from './app/pages/management/index-insert/index-insert.component';
import { DocHistoryComponent } from './app/pages/jornalmove/doc-history/doc-history.component';
import { LogsComponent } from './app/pages/orgmanagement/logs/logs.component';
import { TaskComponent } from './app/pages/orgmanagement/task/task.component';
import { SettingsComponent } from './app/pages/orgmanagement/settings/settings.component';
import { DocApprovalComponent } from './app/pages/jornalmove/doc-approval/doc-approval.component';
import { IndexHistoryComponent } from './app/pages/management/index-history/index-history.component';
import { WorkersInfoComponent } from './app/pages/orgmanagement/workers-info/workers-info.component';
import { MoveinHistoryComponent } from './app/pages/jornalmove/movein-history/movein-history.component';
import { ProfileComponent } from './app/pages/profile/profile.component';

export const appRoutes: Routes = [
	{
		path: '',
		component: AppLayout,
		canActivate: [HomeRedirectGuard],
		canActivateChild: [AuthGuard],
		children: [
			{ path: '', component: Dashboard },
			{ path: 'profile', component: ProfileComponent },
			{
				path: 'journalmove', // This is the parent path: /journalmove
				children: [
					{ path: 'watch', 		component: WatchComponent },
					{ path: 'upload', 		component: UploadFileComponent },
					{ path: 'report', 		component: JournalReportComponent },
					{ path: 'doc-approval', component: DocApprovalComponent },
					{ path: 'doc-history', 	component: DocHistoryComponent },
					{ path: 'movein-history', component: MoveinHistoryComponent}
					// { path: 'traffic', component: JournalTrafficComponent}
				]
			},
			{
				path: 'management', // Parent path for management features
				children: [
					{ path: 'create-account', 		component: CreateAccountComponent },      // Route for creating accounts
					{ path: 'index-insert', 		component: IndexInsertComponent },          // Route for inserting index 
					{ path: 'index-history', 		component: IndexHistoryComponent },        // Route for watching history 
					{ path: 'maintain-accounts', 	component: MaintainAccountComponent }  // Route for maintaining accounts
				]
			},
			{
				path: 'orgmanagement', // Parent path for organizational management features
				children: [
					{ path: 'logs', 		component: LogsComponent },
					{ path: 'workers-info', component: WorkersInfoComponent },
					{ path: 'settings', 	component: SettingsComponent },
					{ path: 'task', 		component: TaskComponent },
				]
			},
			{ path: 'uikit', loadChildren: () => import('./app/pages/uikit/uikit.routes') },
			{ path: 'documentation', component: Documentation },
			{ path: 'pages', loadChildren: () => import('./app/pages/pages.routes') }
		]
	},

	{ path: 'landing', component: Landing },
	{ path: 'notfound', component: Notfound },
	{ path: 'auth', loadChildren: () => import('./app/pages/auth/auth.routes') },
	{ path: '**', redirectTo: '/notfound' }
];
